import { SectionTitleAndSubtitle } from "@/components/SectionTitleAndSubtitle";
import { externalLinks } from "@/utils/external-links";
import { FlashOn, Group, Security, TrendingUp } from "@mui/icons-material";
import { Box, Card, Chip, Container, Grid, Stack, Typography, alpha } from "@mui/material";
import { BenefitCard } from "./BenefitCard";
import { CTAButtons } from "./CTAButtons/CTAButtons";

export function BecomeRepresentativeSection() {
  const benefits = [
    {
      icon: <TrendingUp />,
      title: "Comissões Vantajosas",
      description: "Ganhe comissões atrativas combinadas caso a caso",
    },
    { icon: <Security />, title: "Zero Burocracia", description: "Foque apenas nas vendas, nós cuidamos do resto" },
    { icon: <Group />, title: "Suporte Completo", description: "Equipe técnica especializada para apoiar suas vendas" },
    {
      icon: <FlashOn />,
      title: "Processos Ágeis",
      description: "Análises e processos otimizados para resultados rápidos",
    },
  ];

  return (
    <Box
      component="section"
      sx={{
        py: 10,
        px: 2,
        background: (theme) => alpha(theme.palette.primary.main, 0.03),
      }}
    >
      <Container maxWidth="lg">
        <Box textAlign="center" mb={8}>
          <Chip
            label="Oportunidade de Parceria"
            sx={{
              mb: 3,
              px: 2,
              py: 1,
              fontSize: "0.875rem",
              fontWeight: 500,
              bgcolor: "primary.main",
              color: "primary.contrastText",
            }}
          />

          <SectionTitleAndSubtitle
            title="Seja um Representante RT Soluções Tributárias"
            subTitle="Transforme seu conhecimento em vendas em uma fonte de renda consistente. Junte-se à nossa rede de representantes e ganhe comissões excepcionais."
          />
        </Box>

        <Grid container spacing={3} mb={8}>
          {benefits.map((benefit, index) => (
            <Grid size={{ xs: 12, sm: 6, lg: 3 }} key={index}>
              <BenefitCard {...benefit} />
            </Grid>
          ))}
        </Grid>

        <Card sx={{ mb: 6, borderRadius: 2, p: { xs: 4, md: 6 } }}>
          <Box textAlign="center" maxWidth={800} mx="auto">
            <Typography variant="h4" fontWeight={700} mb={4}>
              Quer aumentar sua renda extra sem se preocupar com burocracias?
            </Typography>

            <Stack spacing={3} fontSize="1.125rem" lineHeight={1.7}>
              <Typography>
                <strong>
                  Na RT Soluções Tributárias, você só indica empresas que possam se beneficiar dos nossos serviços. Todo
                  o trabalho técnico, análises e processos é feito pela nossa equipe especializada.
                </strong>
              </Typography>
              <Typography>
                A comissão é definida de forma personalizada em cada parceria — e posso garantir:{" "}
                <strong>é muito atrativa.</strong>
              </Typography>
            </Stack>
          </Box>
        </Card>

        <Box textAlign="center">
          <Typography variant="h4" fontWeight={700} mb={4}>
            Pronto para começar?
          </Typography>
          <CTAButtons whatsappUrl={externalLinks.tenhoInteresseRepresentanteWhatsapp} email="ricardo@restituir.com" />
        </Box>
      </Container>
    </Box>
  );
}
